import * as ActionTypes from '../ActionTypes'

export const BucketReducer = (state = { 
                errMess: null,
                bucket:{}
            }, action) => {
    switch (action.type) {
        case ActionTypes.SET_BUCKET:
            return {...state, errMess: null, bucket: {...state.bucket, ...action.payload}};
            // return {...state, errMess: null, bucket: action.payload};
        case ActionTypes.ADD_TO_BUCKET:
            return {...state, errMess: null, bucket: {...state.bucket, ...action.payload}};
        case ActionTypes.ADD_SNACKBAR_TO_BUCKET:
            var snackbarArray;
            if(state.bucket.sbArray) {
                snackbarArray = {sbArray: [...state.bucket.sbArray, ...action.payload]};
            }
            else {
                snackbarArray = {sbArray: action.payload};
            }
            return {...state, errMess: null, bucket: {...state.bucket, ...snackbarArray}};
    
        default:
            return state;
    }
};